const T = require("react").PropTypes;

/**
 * Specifies metadata for Nexus uploads.
 * 
 * Type gives us a shape to use in validating data passed to the component.
 * 
 * GetSpecData() generates a "Data" object for a MetadataSpec.
 */
const NexusData = {
    // Factory method
    GetSpecData() {
        const spec = {
            Targets: {
                Loading: false,
                Loaded: false,
                Data: [],
                Error: null
            },
            Target: null,
            IsComplete: false,
            Arg: null
        };

        return spec;
    },
    GetSpecPracticeData() {
        const spec = {
            Targets: {
                Loading: false,
                Loaded: true,
                Data: [
                    { GLCode: "", Description: "Select an account", DisplayOrder: 0 },
                    { GLCode: "0001", Description: "Store 0001", DisplayOrder: 1 },
                    { GLCode: "0545", Description: "Store 0545", DisplayOrder: 2 },
                    { GLCode: "0547", Description: "Store 0547", DisplayOrder: 3 },
                    { GLCode: "0549", Description: "Store 0549", DisplayOrder: 4 },
                    { GLCode: "0599", Description: "Store 0599", DisplayOrder: 5 },
                    { GLCode: "0832", Description: "Store 0832", DisplayOrder: 6 },
                    { GLCode: "0922", Description: "Store 0922", DisplayOrder: 7 },
                    { GLCode: "6786", Description: "Store 6786", DisplayOrder: 8 }
                ],
                Error: null
            },
            Target: null,
            IsComplete: false,
            Arg: null
        };

        return spec;
    },
    // This should mirror the spec type.
    Type: T.shape({
        Targets: T.shape({
            Loading: T.bool,
            Loaded: T.bool,
            Data: T.arrayOf(
                T.shape({
                    Target: T.string,
                    Description: T.string
                })),
            Error: T.object
        }),
        Target: T.string
    })
};

module.exports = NexusData;


// WEBPACK FOOTER //
// ./src/types/metadata/NexusData.js